import React from 'react'
import { Campaign } from '../../../../Api/campaigns'
import { useInputFieldOptions } from './useInputFieldOptions'
import {
  DefaultButton,
  Dialog,
  DialogFooter,
  DialogType,
  PrimaryButton,
} from 'office-ui-fabric-react'

export function ConfirmationDialog({
  originalCampaigns,
  campaignsToSave,
  onClose,
  onConfirm,
  inputField,
  disabled,
}: {
  originalCampaigns: Campaign[]
  campaignsToSave: Campaign[]
  onClose: () => void
  onConfirm: () => void
  inputField: string
  disabled: boolean
}) {
  const inputFieldOptions = useInputFieldOptions()
  const inputFieldOption = inputFieldOptions.find(
    ({ key }) => key === inputField
  )
  const inputFieldText = inputFieldOption ? inputFieldOption.text : ''
  return (
    <Dialog
      hidden={false}
      modalProps={{
        isDarkOverlay: true,
        isBlocking: true,
      }}
      onDismiss={onClose}
      dialogContentProps={{
        type: DialogType.largeHeader,
        title: 'Please confirm',
      }}
    >
      Clicking <strong>Yes</strong> will change{' '}
      <strong>{inputFieldText}</strong> on all the following campaigns:
      <ul>
        {campaignsToSave.map((campaignToSave) => {
          const originalCampaign = originalCampaigns.find(
            ({ id }) => id === campaignToSave.id
          )
          if (campaignToSave.title === originalCampaign!.title) {
            return <li key={originalCampaign!.id}>{originalCampaign!.title}</li>
          }
          return (
            <li key={originalCampaign!.id}>
              {originalCampaign!.title} → {campaignToSave!.title}{' '}
            </li>
          )
        })}
      </ul>
      <DialogFooter>
        <PrimaryButton disabled={disabled} onClick={onConfirm} text="Yes" />
        <DefaultButton disabled={disabled} onClick={onClose} text="No" />
      </DialogFooter>
    </Dialog>
  )
}
